<template>
  <div class="word-wrap" :class="{wrong: isWrong}">
    <div class="question">
      <i class="iconfont icon-voice" @click="listen(testbank.audioUrl)"></i>
      <span class="wrong-word" v-if="isWrong">
        <span
          v-for="(letter, key) in testbank.text"
          :key="key"
          :class="{'right-place': key < wrongIndex}"
        >{{letter}}</span>
      </span>
    </div>
    <div class="explain-wrap">
      <div>
        <el-button size="mini" type="primary" @click="showExplain">
          <span v-if="isShowExplain">隐藏解释</span>
          <span v-else>查看解释</span>
        </el-button>
        <span v-if="isShowExplain" class="explain">{{testbank.explain}}</span>
      </div>
    </div>
    <div class="write">
      <el-input
        placeholder="请输入内容"
        v-model="answer"
        @focus = "listen(testbank.audioUrl)"
        @change="changeAnswer"
        :disabled="isFinish"
      ></el-input>
    </div>
  </div>
</template>
<script>
import { Button, Input } from 'element-ui';
import AudioPlayer from '@/services/audio-player';

export default {
  components: {
    ElButton: Button,
    ElInput: Input,
  },
  props: {
    testbank: {
      type: Object,
      default() {
        return null;
      },
    },
    isListen: {
      type: Boolean,
      default: false,
    },
    typeName: {
      type: String,
      default: '',
      required: true,
    },
    isFinish: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isWrong() {
      const answer = this.answer.trim();
      return answer !== this.testbank.text && this.isFinish;
    },
  },
  data() {
    return {
      answer: '',
      isShowExplain: '',
      wrongIndex: 0,
    };
  },
  methods: {
    showExplain() {
      this.isShowExplain = !this.isShowExplain;
    },
    changeAnswer() {
      for (let i = 0; i < this.testbank.text.length; i += 1) {
        if (this.testbank.text[i] !== this.answer[i]) {
          this.wrongIndex = i;
          break;
        }
      }
      this.answer = this.answer.trim();
      const result = {
        typeName: this.typeName + this.testbank.id,
      };
      if (this.answer === this.testbank.text) {
        result.result = 1;
      } else {
        result.result = 0;
      }
      this.$emit('changeText', result);
    },
    listen(url) {
      AudioPlayer.play(url);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.word-wrap {
  .question {
    padding: 5px 10px;
    background: #f4f4f4;
    font-size: 24px;
    border: 1px solid $border-color;
    font-weight: bold;
    .iconfont {
      font-size: 24px;
      cursor:pointer;
    }
  }
  .explain-wrap {
    padding: 10px;
    height:  65px;
    border: 1px solid $border-color;
    border-top:  none;
    background: #f4f4f4;
    line-height: 28px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .tag {
      display: inline-block;
      background: $primary;
      padding: 0px 5px;
      color: #fff;
    }
    .explain{
      margin-left: 10px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .write {
    width: 100%;
    margin-top: 20px;
  }
}
.wrong {
  .question {
    background: $danger;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-content: center;
    .wrong-word {
      display: inline-block;
      height: 24px;
      padding: 0 8px;
      margin-left: 10px;
      line-height: 20px;
      background: #fff;
      color: $danger;
      border-radius: 24px;
      font-size: 20px;
      .right-place {
        color: $success;
      }
    }
  }
}
</style>
